import React from 'react'
import { useTranslation } from 'react-i18next'

function Loading() {
  const { t } = useTranslation(['global'])

  return (
    <div data-cy="panel-loading" className="panel-loading">
      <i className="fas fa-spinner fa-spin font-size-xl"></i>
      <span>{t('loading')}</span>
    </div>
  )
}

export default Loading
